import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { fireClickedCategoryCardEvent } from '../../CategoryL2Page/utils';
import { getSearchParams } from '../../Parenting/common';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import {
  SubCategoryFilterItem,
  SubCategoryFilterSection,
  SubCategoryFilterSectionNew,
} from './styled';
import { BannerSection } from '../../CategoryL2Page/CategoryGeneralItemListing/styled';

const StickySubCategory = (props) => {
  const {
    categoryWrapHeight,
    filterRef,
    filtersData,
    showHeader,
    categoryId,
    generalItems,
    bottomRef,
  } = props;
  const [activeIndex, setActiveIndex] = useState(null);
  const [showSticky, setShowSticky] = useState(false);
  const router = useRouter();
  const throttleTimeout = useRef();
  const oldScrollValue = useRef(0);
  const callbackFunction = (index, deeplinkValue) => {
    setTimeout(() => {
      router.push(`${deeplinkValue}` + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };

  const filterClickHandler = (data, index) => {
    setActiveIndex('filter' + index);
    fireClickedCategoryCardEvent({
      card_name: data?.name?.slice(0, 99),
      card_id: data?._id,
      section_name: filtersData?.itemName || filtersData?.heading,
      section_id: filtersData?._id,
      id: categoryId,
      deeplink_value: data?.webUrl || data?._id,
    });
    setTimeout(() => {
      setActiveIndex(null);
    }, 1000);
  };
  useEffect(() => {
    const ele = document.getElementById('gridViewCat');
    const boundingELe = ele.getBoundingClientRect();
    const offsetTop = ele?.offsetTop + boundingELe.height;
    const bottomOffset = document
      .getElementById('bottomRef')
      ?.getBoundingClientRect();

    function handleStickyScroll() {
      if (!throttleTimeout.current) {
        setTimeout(() => {
          let value = window.scrollY;
          if (
            value > offsetTop &&
            value < bottomOffset?.top &&
            oldScrollValue.current > value
          )
            setShowSticky(true);
          else {
            setShowSticky(false);
          }
          oldScrollValue.current = value;
          throttleTimeout.current = false;
        }, 100);
      }
      throttleTimeout.current = true;
    }

    window.addEventListener('scroll', handleStickyScroll);
    return () => {
      window.removeEventListener('scroll', handleStickyScroll);
    };
  }, [categoryId]);
  return (
    <>
      <SubCategoryFilterSectionNew id="gridViewCat">
        {filtersData?.items?.map((item, index) => {
          const l2CatData = generalItems?.filter(
            (element) => element.itemName === item.name,
          );
          const singleProduct = l2CatData?.[0]?.items?.length === 1;
          const catWebUrl = singleProduct
            ? l2CatData?.[0]?.items?.[0]?.webUrl
            : item?.webUrl || item?._id;
          return (
            <BannerSection
              key={`ban_${index}`}
              className={`bannerSection ${
                activeIndex == 'filter' + index ? 'lowOpacity' : ''
              }`}
              start={item?.sectionBgColorStart}
              end={item?.sectionBgColorEnd}
              onClick={() => {
                filterClickHandler(item, index);
              }}
            >
              <AnchorCoverTag
                url={catWebUrl}
                callbackFunction={callbackFunction}
              >
                <div className="bannerContainer">
                  <div className="textSection">
                    <p>{item?.name}</p>
                  </div>
                  <img src={item?.icon} alt="" />
                </div>
              </AnchorCoverTag>
            </BannerSection>
          );
        })}
      </SubCategoryFilterSectionNew>
      <SubCategoryFilterSection
        ref={filterRef}
        showHeader={showHeader}
        showSticky={showSticky}
        categoryWrapHeight={categoryWrapHeight}
      >
        {filtersData?.items?.map((item, index) => {
          const l2CatData = generalItems?.filter(
            (element) => element.itemName === item.name,
          );
          const singleProduct = l2CatData?.[0]?.items?.length === 1;
          const catWebUrl = singleProduct
            ? l2CatData?.[0]?.items?.[0]?.webUrl
            : item?.webUrl || item?._id;
          return (
            <SubCategoryFilterItem
              className={activeIndex == 'filter' + index ? 'active' : ''}
              onClick={() => {
                filterClickHandler(item, index);
              }}
              key={'subCategory' + index}
            >
              <AnchorCoverTag
                url={catWebUrl}
                callbackFunction={callbackFunction}
              >
                {' '}
                <div className="imgWrapper">
                  <Image
                    src={item?.icon}
                    alt=""
                    quality={90}
                    fill
                    sizes="33vw"
                  />
                </div>
                <p>{item?.name}</p>
              </AnchorCoverTag>
            </SubCategoryFilterItem>
          );
        })}
      </SubCategoryFilterSection>
    </>
  );
};

export default StickySubCategory;
